import React, { useEffect, useState } from "react";
import PartnerCompany from "../../../AllPageComponents/PartnerCompany/PartnerCompany";
import FAQ from "../../../AllPageComponents/FAQ/FAQ";
import { Link } from "react-router-dom";
import FastImage from "../../../FastImage";
import { auto } from "@patternfly/react-core/dist/esm/helpers/Popper/thirdparty/popper-core";
import Redirect from "../../../AllPageComponents/Rederict";
import { Helmet } from "react-helmet-async";

const HealthInsureClamesttelment = () => {
  const ClaimArray = [
    {
      id: 0,
      Qustion: "Q.What is cashless claim settlement?",
      anwsar:
        "A. The cashless claim settlement facility allows the policyholder to avail treatment benefits at the network hospital without worrying about the expenses.  The bill in case of cashless cases are settled or resolved directly between the insurance provider and the partner hospital. However, the policyholder pays for the costs exclusively that aren’t covered under the cashless facility. Yes, the policyholder can use this facility at any of the network hospitals of the insurer that provides cashless claim settlement facilities. Never forget to note down the names of the network hospitals for availing cashless claim settlement because the patient needs to get admitted in a network hospital. Every insurance company has their own set of network hospitals. it is very essential for every policyholder to have the information and knowledge about the listed hospitals in the company’s network as it’s always preferred for an individual to choose the location and area according their convenience. Most suitably providing cashless facility.",
    },
    {
      id: 1,
      Qustion:
        "Q.Does your health insurance policy cover you all across India?",
      anwsar:
        "A. You really cannot anticipate when a medical emergency will occur. Hence, it is wise to be alert and cautious of the teretorrial limitations of the claim settlement in the policy in advance. Health insurance policies provide coverage across India; however, it is best to clarify all your queries about the same before a confirming your decision regarding purchasing your health insurance plan. Stay informed that there are also some medical insurance plans that provide international health insurance coverage as well.",
    },
    {
      id: 2,
      Qustion:
        "Q.Are the pre-existing diseases covered under the health insurance?",
      anwsar:
        "A. Pre-existing diseases is something that varies from policy to policy. A policy offering cover for a pre-existing condition will get tagged along with a certain waiting period applicable on the coverage. Without fail find out the waiting period for your pre-existing diseases and how early you are eligible to be covered. To conclude, having a clear picture of whether your pre-existing condition is not covered in the interim or is it entirely excluded from the option of coverage is must before purchasing the policy.",
    },
    {
      id: 3,
      Qustion:
        "Q. Whom to contact in case any emergency hospitalization happens?",
      anwsar:
        "A. Medical exigencies ask for quick surveillance and awareness; that’s why it is recommended that you concentrate on taking the patient to the nearest network hospital for hospitalization. After you get admitted the family members of the patient must contact the insurance provider or the Third-Party Administration (TPA) to inform about the hospitalization and get the best possible guidance related to claim settlement procedure.",
    },
    {
      id: 4,
      Qustion:
        "Q Willing to claim for treatments availed at a non-network hospital?",
      anwsar:
        "A. A. Sometime, we are left with no option but to get the insured policyholder hospitalized at a non-network hospital under an emergency situation and circumstances. In such occurrences, one can apply for a reimbursement claim post completion of treatment. In such a case, the insured gets treated, pay for the treatment availed, and then file for a reimbursement claim. All expenses are covered under the policy overage, except for ones which doesn’t fall under the category.",
    },
    {
      id: 5,
      Qustion:
        "Q. What about the proper documentation to file a health insurance claim?",
      anwsar:
        "A. Documents are submitted at the time of filing a claim on your health insurance policy. It is mandatory Most commonly, a health insurance company asks the policyholder to place the ID proof of the insured individual,and the health card issued by the insurance company. The invoices, other necessary medical documents, bills and invoices for the treatment availed are equally essential In case of cashless hospitalization, the insured individual also submits a pre-authorization form to the TPA. For availing reimbursement facility, policyholder is required to provide relevant bills plus the other valid documents for the claimed amount to the TPA.",
    },
  ];

  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const initialText =
    "With Beema1, get top-rated health insurance plans online. You can compare online and buy the most suitable insurance plan for you and your family. You can also get your queries answered by our team of experts.";

  const [showFullText, setShowFullText] = useState(false);

  const toggleShowFullText = () => {
    setShowFullText(!showFullText);
  };

  const [Readmore, setReadmore] = useState(true);

  const HandelReadmore = () => {
    setReadmore(!Readmore);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="car-insurance insurance-all main-health main-health mainnargin-insurance">
        <div className="container">
          <Redirect />
          <div className="row insurance-row-one">
            <div className="col-sm-12 col-md-4 col-lg-4 mian-one ">
              <div className="healthdiscription">
                {/* <h1>
Best Claim Settlement Ratio Of Health Insurance Plans</h1> */}
                <h1>
                  Compare best claim settlement ratio of health insurance
                  companies
                </h1>
                <div>
                  <span style={{ textAlign: "justify" }}>{initialText}</span>
                </div>
              </div>
              <div className="insurance-btn-set">
                <button
                  type="button"
                  className="reminderbutton"
                  data-toggle="modal"
                  data-target="#reminderpopup"
                >
                  {" "}
                  <svg
                    stroke="currentColor"
                    fill="none"
                    strokeWidth={2}
                    viewBox="0 0 24 24"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fontSize="15pt"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ color: "rgb(251, 167, 27)", margin: "0px 5px" }}
                  >
                    <circle cx={12} cy={13} r={8} />
                    <path d="M12 9v4l2 2" />
                    <path d="M5 3 2 6" />
                    <path d="m22 6-3-3" />
                    <path d="M6.38 18.7 4 21" />
                    <path d="M17.64 18.67 20 21" />
                  </svg>{" "}
                  Set Reminder
                </button>
              </div>
            </div>
            <div className="col-sm-12 col-md-4 col-lg-4 side-image">
              <FastImage
                url={
                  "Website%20Img/mascot_image1678942204.png?updatedAt=1718776425936"
                }
                width={auto}
                height={auto}
                alt={"arrow"}
                src={
                  "Website%20Img/mascot_image1678942204.png?updatedAt=1718776425936"
                }
              />
            </div>
            <div className="col-sm-12 col-md-4 col-lg-4 popup-main">
              <div className="form-main">
                <form id="insurance_form_get_plan">
                  <div className="d-flex align-items-center form-input">
                    <h6>
                      Compare &amp; Buy Customized Health Plans starting at just
                      <span className="specialprice">Rs ₹257/month*</span>
                    </h6>
                    <div className="blue-btn">
                      <Link to={"/healthStep1"}>
                        <button
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            color: "white",
                            fontWeight: 400,
                          }}
                        >
                          Get Your Quotes
                        </button>{" "}
                        <img alt="" src="" className="" />
                      </Link>
                    </div>
                    <p className="insurance-text-light">
                      By clicking, I agree to{" "}
                      <a href="/termsandcondition">*terms &amp; conditions</a>{" "}
                      and <a href="/privacy-policy">privacy policy</a>.
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="inbulitmargine"></div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            The Ratio Of Health Insurance Claim Settlement
          </h1>
          <div className="yellowline"></div>

          <p className="textformat">
            Health insurance claim settlement ratio can be stated as a marked
            performance that indicates how well an insurance company handles the
            claims of its clients. In actual fact-based terms, it is the number
            of claims an insurance company pays off which is divided by the
            total number of claims the insurance company receives in a year. The
            settlement ratio of the health insurance companies help people
            interpret if the insurance provider is standard and responsible at
            taking care of their customers' claims.
          </p>
          <div className="row">
            <div className="col-md-12">
              <p className="textformat">
                <b className="qustionTag">
                  Best Health Insurance Companies with High Claim Settlement
                  Ratio:- &nbsp;
                </b>
                Selecting list of insurance providers based on their exemplary
                health insurance claim settlement ratio for the financial year
                2022. You can compare best health insurance ratio by following
                the below mentioned insurers.
              </p>

              <div className="tebildivs">
                <table className="claimsSettlementTable">
                  <thead>
                    <tr className="claimsSettlementTable-header">
                      <th className="claimsSettlementTable-headerCell">
                        Si No.
                      </th>
                      <th className="claimsSettlementTable-headerCell">
                        Insurer
                      </th>
                      <th className="claimsSettlementTable-headerCell">
                        CSR in % (FY22)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      {
                        id: 1,
                        name: "ICICI Lombard General Insurance Co. Ltd.",
                        csr: "99.70%",
                      },
                      {
                        id: 2,
                        name: "HDFC ERGO General Insurance Company Ltd.",
                        csr: "100.00%",
                      },
                      {
                        id: 3,
                        name: "Reliance General Insurance Company Ltd",
                        csr: "100.00%",
                      },
                      {
                        id: 4,
                        name: "Care Health Insurance Co. Ltd.",
                        csr: "95.22%",
                      },
                      {
                        id: 5,
                        name: "Star Health and Allied Insurance Co. Ltd.",
                        csr: "89.90%",
                      },
                      {
                        id: 6,
                        name: "Star Health and Allied Insurance Co. Ltd",
                        csr: "89.90%",
                      },
                      {
                        id: 7,
                        name: "Zuno General Insurance Company Ltd.",
                        csr: "94.00%",
                      },
                      {
                        id: 8,
                        name: "The New India Assurance Co. Ltd.",
                        csr: "92.68%",
                      },
                    ].map((insurer) => (
                      <tr
                        key={insurer.id}
                        className="claimsSettlementTable-row"
                      >
                        <td className="claimsSettlementTable-cell">
                          {insurer.id}
                        </td>
                        <td className="claimsSettlementTable-cell">
                          {insurer.name}
                        </td>
                        <td className="claimsSettlementTable-cell">
                          {insurer.csr}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Procedure of Filing A Health Insurance Claim
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12">
              <p className="textformat">
                In health insurance, the term, “claim settlement” is defined,
                identified and recognized as the act of an insurance provider
                paying money to the insured in case of any hospitalization
                expenses. The position and dignity of a policy owner is
                designated by claim settlement. Filing an insurance claim means
                you are allowing your insurance company know about a specific
                loss and ask that it pays the related expenses. You'll need
                to fill out a "proof of loss" form to file a claim.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            What Is Health Insurance Claim and How Is It Paid ?
          </h1>
          <div className="yellowline"></div>
          <p className="textformat">
            {" "}
            Insurance claim is an appeal that is filed with your insurance
            provider requesting to pay for a covered loss. An insurance claim is
            a set of documents you file with your insurer (the insurance
            company) after an accident. If the accident is covered by your
            insurance policy, the insurance company will cover your costs. You
            can make insurance claims for a damage to your car, your bike or
            home, injuries due to any accident, health care & medical checkups
            and life insurance benefits. It may extend few weeks to a few months
            for the insurance company to compensate your claim. The duration of
            the claims process is based on the type and size of your claim.
          </p>
          <div className="row">
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <p className="textformat" style={{ textAlign: "justify" }}>
                <span className="specialprice">Health insurance claim:-</span>{" "}
                Most people only get involved in the claim procedure if their
                company denies to pay claims or their insurance only covers a
                portion of the costs. In such situation, you can demand or
                appeal the decision if you believe your plan should cover the
                services. Any which ways, it does not provide a clear picture
                whether the insurer paid the entire claim amount or only a
                portion of it. Claim settlement also does not demonstrate the
                time spent by the insurance provider in processing the request
                from the policyholder. If a claim settlement is declined or
                partially declined, one must inspect and examine the reason for
                the claim getting fully declined or partially declined. If
                required, the grievance team needs to be addressed for further
                review.
              </p>
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <FastImage
                url="/Website%20Img/patient_5996300.png?updatedAt=1730113295582"
                width={auto}
                height={auto}
                className="fmailimagegifs"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">Why Your Claim Is Usually Rejected?</h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12">
              <p className="textformat">
                <span className="specialprice">
                  1.Non-Disclosure Of Pre-Existing Diseases:-
                </span>
                Most people do not reveal pre-existing diseases with an
                anticipation that the insurance provider has no options of
                finding out the truth. Well, this may be a fact at the
                application phase, they generally find out if you’ve been
                confining or beholding information during hospitalization. They
                thoroughly and meticulously read in between the lines of the
                discharge summary and other medical documents you provide. If
                they happen to find out that you have failed to disclose any
                information associated to your pre-existing diseases, they will
                reject your claim and may even decline the policy.
              </p>

              <p className="textformat">
                <span className="specialprice">
                  2. Claiming During Waiting Periods:-
                </span>
                Insurers also have waiting periods for pre-existing ailments
                including certain ailments like cataracts, asthma and kidney
                stones. They will not cover your claim during this period.
                Therefore, be prepared in advance and ensure that your claim
                isn’t rejected during the cooling off period. Be wise and spend
                buying a policy with little to no waiting periods.
              </p>
              <p className="textformat">
                <span className="specialprice">
                  3.Non-Coverage Of Non-Medical Expenses And Consumables:_
                </span>
                Insurance companies usually eliminate non-medical expenses like
                hospital administration charges and expenses related to
                consumables i.e. things like gloves, syringes, PPE kits. So if
                you ever thought of these costs to be covered, then you need to
                buy an insurance plan that absolutely covers consumables and
                non-medical expenses.
              </p>
              <p className="textformat">
                <span className="specialprice">
                  4. Making A Claim In A Hospital Blacklisted By The Insurance
                  Company:-
                </span>
                Insurance companies will also tell you that they will never
                cover expenses if you are hospitalized in a health care facility
                that is blacklisted. Hospitals are generally blacklisted if they
                have a track record of inflating bills. Hence, if you have to
                get hospitalized at any point of time, make sure to check the
                names of the blacklisted hospitals to avoid claim rejection.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="fixwidthDivtext">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="paddingbox">
                <div className={Readmore ? "Readmoreclmst" : "Readless"}>
                  <h1 className="healthHeading">
                    What to do if your claim is rejected?
                  </h1>
                  <div className="yellowline"></div>
                  <p className="textformat">
                    {" "}
                    <b>
                      If your health insurance claim is rejected, then you can
                      follow the below mentioned steps:{" "}
                    </b>
                  </p>

                  <p className="textformat">
                    (i) You can write to the insurance company or your insurance
                    agent, or the insurance broker, that means the intermediator
                    asking for a written explanation for the rejection of the
                    claim. If you do not feel content and satisfied with the
                    reasons explained, you can surely write to the grievance
                    department of the insurance company. You can find the email
                    addresses of the grievance cells of different insurers on
                    the websites of the respective insurance companies. If you
                    don’t receive any reply within 30 days, or you remain
                    unsatisfied with the solution provided, you can further
                    approach the Insurance Ombudsman by visiting their
                    website and filing a complaint online with the Ombudsman
                    office in your area. The Ombudsman will deal with the query
                    and handle the complaint after hearing all parties and shall
                    finish off the matter. Or else, you can also file a
                    complaint in the Consumer Court. Generally, we advise people
                    to do this only after they approach the Insurance Ombudsman.
                    So, let’s look at this subject in a little more detail.
                  </p>

                  <span className="qustionTag">For instance:</span>

                  <p className="textformat">
                    One of our clients sustained an Ankle Ligament
                    Reconstruction or Repair injury after falling down the
                    stairs. Initially, the insurance company declined the claim,
                    citing a two-year exclusion period for Ankle Ligaments
                    Reconstruction surgeries. However, the policy also
                    consistently includes a provision for immediate coverage of
                    accidental injuries. We debated The rejection, affirming
                    that this was an accident and therefore should be covered.
                    Ultimately, the insurance company accepted and sanctioned
                    the claim. A written description with evidence helps you
                    better analyze future options and this should be the first
                    thing you do once your claim is denied.
                  </p>

                  <p className="textformat">
                    (ii) If you are unhappy with the insurance provider’s
                    response, you can definitely write to the company’s
                    grievance cell. Grievance cells usually operate freely.
                    Their responsibility is to deal with the claim, and to
                    inspect the reasons for rejection. They also have to
                    classify whether the company has acted reasonably. If they
                    feel like the claims team have not dealt with your case with
                    proper justice, they can action a reversal of rejection and
                    approve your claim. For this you will need to find the email
                    address of the grievance cell for your insurer. Generally,
                    they have an online complaints form. If they don’t, you can
                    simply send them an email including your policy number,
                    claim indication number, and why you feel your claim is
                    legitimate. You will be updated within 30 days of time. Our
                    general experience says hardly the grievance cell reverse
                    the claim team’s decision. The crude reality of the
                    situation is that regardless of knowing this fact, we can’t
                    bypass this step as you can only approach the Insurance
                    Ombudsman after you receive a reply from the grievance cell.
                    Or if you don’t hear from them in 30 days.
                  </p>
                  <p className="textformat">
                    (iii) So, if you are not satisfied with the decision or the
                    verdict provided by the Insurance company’s grievance cell,
                    then you can forward your complaint to the Insurance
                    Ombudsman by visiting the website here. Make sure that you
                    approach the right office. There are different Ombudsman for
                    different territories. You need to first check the “Offices
                    of Ombudsman” under the “About Us” section to find out which
                    office lies in your jurisdiction. Once you do this, you can
                    then click on the "Register complaint" under the Section
                    "Complaint Online" on the website and fill in the
                    information they seek. The Ombudsman will take some time
                    before they reply to your complaint. If they see integrity
                    in your claim, they may seek a feedback or reciprocation
                    from the insurance company and even conduct a virtual
                    hearing. But, if they find out that the insurer denied an
                    authentic claim for improbable reasons, then they will award
                    the claim amount and supplementary allowance wherever they
                    see fit. If you are unsatisfied with the award, you can then
                    approach and access the opportunity of the consumer court
                    and go all the way to the Supreme Court if you decide to do
                    so. However, the cost involved in it may not be worth it if
                    you are brawling over a claim, totaling a few thousand
                    rupees. To conclude, you are the one to decide for yourself.
                  </p>
                </div>
                <div className="redbtn">
                  <button className="Readmorebtn" onClick={HandelReadmore}>
                    {Readmore ? "Read More" : "Read Less"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PartnerCompany />
      <FAQ />
    </>
  );
};

export default HealthInsureClamesttelment;
